document.addEventListener('DOMContentLoaded', function() {
  // Handle quantity selector
  const quantitySelectors = document.querySelectorAll('.everyday-art-landing .quantity-selector');
  quantitySelectors.forEach(selector => {
    const decrement = selector.querySelector('.decrement');
    const increment = selector.querySelector('.increment');
    const input = selector.querySelector('.quantity');

    decrement.addEventListener('click', () => {
      let value = parseInt(input.value);
      if (value > 1) {
        input.value = value - 1;
      }
    });

    increment.addEventListener('click', () => {
      let value = parseInt(input.value);
      input.value = value + 1;
    });
  });

  // Handle variant selection and price update
  const variantPickers = document.querySelectorAll('.everyday-art-landing .variant-picker');
  variantPickers.forEach(picker => {
    picker.addEventListener('change', function() {
      const selectedOption = this.options[this.selectedIndex];
      const price = selectedOption.getAttribute('data-price');
      const productCard = this.closest('.product-card');
      const priceElement = productCard.querySelector('.price');
      priceElement.textContent = price;

      // Update the data-variant-id on the Add to Cart button
      const variantId = this.value;
      const addToCartButton = productCard.querySelector('button[data-add-to-cart]');
      if (addToCartButton) {
        addToCartButton.setAttribute('data-variant-id', variantId);
      }
    });
  });

  // Handle Add to Cart form submission
  const forms = document.querySelectorAll('.everyday-art-landing .add-to-cart-form');
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault(); // Prevent default form submission

      const variantId = form.querySelector('select[name="id"]').value;
      const quantity = form.querySelector('input[name="quantity"]').value;
      const addToCartButton = form.querySelector('button[data-add-to-cart]');

      // Disable the button to prevent multiple submissions
      if (addToCartButton) {
        addToCartButton.disabled = true;
        addToCartButton.classList.add('is-loading');
      }

      // Use Shopify's AJAX API to add the item to the cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status) {
          // Handle error (e.g., out of stock)
          console.error('Error adding item to cart:', data);
          if (addToCartButton) {
            addToCartButton.disabled = false;
            addToCartButton.classList.remove('is-loading');
          }
          return;
        }

        // Successfully added to cart
        if (addToCartButton) {
          addToCartButton.classList.remove('is-loading');
          addToCartButton.classList.add('is-added');
          setTimeout(() => {
            addToCartButton.classList.remove('is-added');
            addToCartButton.disabled = false;
          }, 1000);
        }

        // Dispatch the theme:product:added event to trigger the cart drawer
        document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));

        // Fetch the updated cart to ensure the cart UI updates
        fetch('/cart?section_id=api-cart-items')
          .then(response => response.text())
          .then(cartData => {
            // Update the cart UI (this should trigger the build method in <cart-items>)
            const cartItems = document.querySelector('cart-items');
            if (cartItems) {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = cartData;
              const apiContent = tempDiv.querySelector('[data-api-content]');
              if (apiContent) {
                cartItems.build(apiContent);
              }
            }

            // Additional event to ensure the cart drawer opens
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          })
          .catch(error => {
            console.error('Error fetching updated cart:', error);
            if (addToCartButton) {
              addToCartButton.disabled = false;
              addToCartButton.classList.remove('is-loading');
            }
          });
      })
      .catch(error => {
        console.error('Error adding item to cart:', error);
        if (addToCartButton) {
          addToCartButton.disabled = false;
          addToCartButton.classList.remove('is-loading');
        }
      });
    });
  });
});